import * as React from 'react';
import '../css/CCPA-banner.sass';
import { createCookie, getCookie } from '../utils/cookie';
import CampfireButton from './CampfireButton';

interface CCPABannerProps {
  children: React.ReactNode;
  btnLabel?: string;
}
interface CCPABannerState {
  open: boolean;
}

export default function CCPABanner(props: CCPABannerProps) {
  const { btnLabel = 'Accept Cookies' } = props;
  const [state, setState] = React.useState<CCPABannerState>({
    open: true
  });

  const CCPACookie = getCookie('ccpa-cookies-aggrement');
  if (!state.open || CCPACookie === 'ccpa-cookies-aggrement') {
    return <></>;
  }
  return (
    <>
      <div className="ccpa">
        <div className="content">
          <div className="t-16">{props.children}</div>
          <CampfireButton
            name="Cookies"
            id="ccpaCookies"
            label={btnLabel}
            color="marshmallow"
            smol
            onClick={() => {
              createCookie('ccpa-cookies-aggrement', 'ccpa-cookies-aggrement');
              setState({ open: false });
            }}
          />
        </div>
      </div>
    </>
  );
}
